@if (hasNotificationsToShow | async) {
  <div class="notification-flash">
    @for (notification of notifications | async; track notification) {
      <ftr-notification [type]="notification.type" [markdown]="true">
        {{ notification.message }}
      </ftr-notification>
    }
  </div>
}
